import React from "react";
import { Box, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useDispatchWrapper } from "../../../../../../hooks";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { fetchBusinessPolicyRestrutantListAsync } from "../../../../../../redux/businessPolicy/businessPolicyRestrutant/businessPolicyRestrutantActions";
import { IBusinessPolicyRestrutant } from "../../../../../../redux/businessPolicy/businessPolicyRestrutant/businessPolicyRestrutant.types";

export const RestrurantQuestionareList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.business.restrutant
  );
  const dispatch = useDispatchWrapper();

  const restrutanTableProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/business-policy/${customerId}/questionnare-tab/${customerPolicyId}/resturant`
                  );
                }}
              >
                Add Restaurant
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: IBusinessPolicyRestrutant) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/business-policy/${customerId}/questionnare-tab/${customerPolicyId}/resturant/${row.incremental_number}`
                )
              }
            >
              {row.incremental_number}
            </Link>
          );
        },
      },

   

    
      {
        key: "year_in_business",
        headerName: "Year in Business",
        fieldName: "year_in_business",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },
      {
        key: "family_run_business",
        headerName: "Family in Business",
        fieldName: "family_run_business",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },
      {
        key: "year_of_current_ownership",
        headerName: "Year of Current Ownership",
        fieldName: "year_of_current_ownership",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },
      {
        key: "insert_ts",
        headerName: "Date Created",
        fieldName: "insert_ts",
        renderType: RenderType.DATE,
        exportCellWidth: 20,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IBusinessPolicyRestrutant) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/business-policy/${customerId}/questionnare-tab/${customerPolicyId}/resturant/${row.incremental_number}`
                );
              }}
            />
          );
        },
      },
    ],
    items: data,
  };

  React.useEffect(() => {
    dispatch(fetchBusinessPolicyRestrutantListAsync(customerPolicyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPolicyId]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...restrutanTableProps} />
      </Box>
    </>
  );
};
